"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setStepVisibility = setStepVisibility;
exports.getStepVisibility = getStepVisibility;

var _metrixCommon = require("metrix-common");

function setStepVisibility(step, returns) {
    if (step.containers && step.containers.length > 0) {
        step.containers.forEach(function (container, i, containers) {
            return containers[i] = setContainerVisibility(container, returns);
        });
    }

    return step;
}

function setContainerVisibility(container, returns) {
    if (container.containers && container.containers.length > 0) {
        container.containers.forEach(function (nestedContainer, i, containers) {
            return containers[i] = setContainerVisibility(nestedContainer, returns);
        });
    } else {
        container.components.forEach(function (component, i, components) {
            return components[i] = setComponentVisibility(component, returns);
        });
    }

    return container;
}

function setComponentVisibility(component, returns) {
    var visible = true;

    var visibilityRules = (0, _metrixCommon.getElementsByType)(component.elements, "conditionalRender");

    if (visibilityRules) {
        var processed = false;
        visibilityRules.forEach(function (visibilityRule) {
            visibilityRule.elements.forEach(function (rule) {
                var componentCode = rule.code;
                var payload = getReturnByComponentCode(componentCode, returns);
                if (payload) {
                    var comparisonValue = (0, _metrixCommon.getReturnElementByCode)(payload, "option");
                    var ruleValue = rule.value;
                    if (comparisonValue) {
                        visible = visible && evaluateExpression(comparisonValue, ruleValue);
                    }
                } else {
                    visible = false;
                }
            });
        });
    }

    component = setVisibilityElement(component, visible);

    return component;
}

function evaluateExpression(comparisonValue, ruleValue) {
    // TODO: This  method has no flexibility and needs to be reworked

    var result = false;

    var greaterOrLess = ruleValue.split("").some(function (char) {
        return char === "<" || char === ">";
    });
    var notCondition = ruleValue.indexOf("!") === 0;
    var regularCondition = !greaterOrLess && !notCondition;

    if (greaterOrLess) {
        switch (ruleValue) {
            case "< 3":
                result = Number(comparisonValue) < 3;
                break;
            case "YearFromNow > 10":
                result = new Date().getFullYear() - Number(comparisonValue) > 10;
                break;
        }
    } else if (notCondition) {
        result = ruleValue.split("!")[1] !== comparisonValue;
    } else {
        result = ruleValue === comparisonValue;
    }

    return result;
}

function setVisibilityElement(component, visible) {
    if (!component.elements) {
        component.elements = [];
    }

    if (component.elements.some(function (x) {
        return x.code === "visible";
    })) {
        component.elements.find(function (x) {
            return x.code === "visible";
        }).value = visible;
    } else {
        component.elements.push({ code: "visible", value: visible });
    }

    return component;
}

function getReturnByComponentCode(code, returns) {
    var payload = null;

    if (returns && returns.length > 0 && returns.some(function (x) {
        return x.code === code;
    })) {
        payload = returns.find(function (x) {
            return x.code === code;
        });
    }

    return payload;
}

function getStepVisibility(step, returns) {

    if (returns && returns.length > 0) {
        if (step.containers && step.containers.length > 0) {
            step.containers.forEach(function (container, i, containers) {
                returns = getContainerVisibility(container, returns);
            });
        }
    }

    return returns;
}

function getContainerVisibility(container, returns) {
    if (container.containers && container.containers.length > 0) {
        container.containers.forEach(function (nestedContainer, i, containers) {
            returns = getContainerVisibility(nestedContainer, returns);
        });
    } else {
        container.components.forEach(function (component, i, components) {
            returns = getComponentVisibility(component, returns);
        });
    }

    return returns;
}

function getComponentVisibility(component, returns) {
    var visible = true;

    if (component && component.elements && component.elements.some(function (x) {
        return x.code === "visible";
    })) {
        visible = component.elements.find(function (x) {
            return x.code === "visible";
        }).value;
    }

    if (!visible) {
        if (returns.some(function (x) {
            return x.code === component.code;
        })) {
            if (component.type !== "slider") {
                returns = returns.filter(function (x) {
                    return x.code !== component.code;
                });
            }
        }
    }

    return returns;
}